import { Link } from 'react-router-dom'
import { CARD_ITEM_TYPE } from '../../constants.js'
import './CardItem.css'

export default function CardItem({ item }) {
  console.log('CardItem rendered', item)

  let pathName = ''
  let target = ''
  if (parseInt(item.type.id) === CARD_ITEM_TYPE.query) {
    if (item.search) {
      pathName = `/search/${item.search.id}`
      if (item.showCreateLink === 'N') {
        pathName += '?addButton=N'
      }
      if (item.showViewLink === 'N') {
        pathName += '&viewLink=N' 
      }
    }
  } else if (parseInt(item.type.id) === CARD_ITEM_TYPE.newDocument) {
    if (item.objectType) {
      pathName = `/create/${item.objectType.id}`
    }
  } else if (parseInt(item.type.id) === CARD_ITEM_TYPE.hyperlink) {
    let prefix = 'custom'
    if (item.url.includes('data_quality.count_report')) {
      prefix = 'nonav/custom'
      target = '_blank'
    }
    pathName = `/${prefix}/${item.url}`
  }

  if (pathName) {
    return (
      <Link className="card-item" to={pathName} target={target} data-cy-home-card-link-button={item.text.toLowerCase().replace(/ /g, '-')}>{item.text}</Link>
    )
  }
  return item.text
}
